import React from "react";
import ValidationContent from "./testingValidationContent";
import LabTesting from "./img/lab-testing-validation.jpg";
import IconFaAngleDL from "../img/IconFaAngleDL";
import IconFaAngleDR from "../img/IconFaAngleDR";
import IconFaMobile from "../img/IconFaMobile";
import IconFaTablet from "../img/IconFaTablet";
import IconFaDesktop from "../img/IconFaDesktop";
import IconFaCheck from "../img/IconFaCheck";
import IconFaMinus from "../img/IconFaMinus";

function ValidationSection() {
	return (
		<>
			<section className="content-block" id={ValidationContent.meta}>
				<h4 className="section-title-meta"> {ValidationContent.meta} </h4>
				<h3 className="section-title">{ValidationContent.title}</h3>
				{ValidationContent.paras.map((p) => {
					return <p>{p}</p>;
				})}
				<figure className="image">
					<span className="border">
						<img src={LabTesting} alt={ValidationContent.img01alt} />
					</span>
					<figaption>{ValidationContent.img01caption}</figaption>
				</figure>
				<figure className="table-block">
					<table className="table-insights">
						<thead>
							<tr>
								<th>Key Performance Indicator</th>
								<th>
									<IconFaMobile aria-hidden="true" /> Mobile
								</th>
								<th>
									<IconFaTablet aria-hidden="true" /> Tablet
								</th>
								<th>
									<IconFaDesktop aria-hidden="true" /> Desktop
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Online Bookings</td>
								<td>
									<IconFaMinus aria-hidden="true" />
									<span class="kpi-positive">Neutral</span>
								</td>
								<td>
									<IconFaMinus aria-hidden="true" />
									<span class="kpi-neutral">Neutral</span>
								</td>
								<td>
									<IconFaCheck aria-hidden="true" />
									<span class="kpi-negative">Positive</span>
								</td>
							</tr>
							<tr>
								<td>Phone Enquiries</td>
								<td>
									<IconFaCheck aria-hidden="true" /> Positive
								</td>
								<td>
									<IconFaMinus aria-hidden="true" /> Neutral
								</td>
								<td>
									<IconFaCheck aria-hidden="true" /> Positive
								</td>
							</tr>
							<tr>
								<td>Email Enquiries</td>
								<td>
									<IconFaMinus aria-hidden="true" /> Neutral
								</td>
								<td>
									<IconFaCheck aria-hidden="true" /> Positive
								</td>
								<td>
									<IconFaCheck aria-hidden="true" /> Positive
								</td>
							</tr>
						</tbody>
					</table>
				</figure>
			</section>
			<blockquote className="quote">
				<IconFaAngleDL />
				<span className="statement">{ValidationContent.quote.statement}</span>
				<span className="personna">{ValidationContent.quote.personna}</span>
				<IconFaAngleDR />
			</blockquote>
		</>
	);
}

export default ValidationSection;
